import { Component } from '@angular/core';

@Component({
  selector: 'ls-update-warning',
  templateUrl: './update-warning.component.html',
  styleUrls: ['./update-warning.component.scss']
})
export class UpdateWarningComponent {
  public getUrl(language: string): string {
    return '../' + language + '/#/update-warning' + location.search;
  }
}
